import importer from "common/importer";

const getDrupalPreviewContent = importer("Sagas/Global/preview/main");
const getDrupalPreviewContentSuccess = importer("Sagas/Global/preview/success");
const getDrupalPreviewContentFailure = importer("Sagas/Global/preview/failure");

export default {
  getDrupalPreviewContent,
  getDrupalPreviewContentSuccess,
  getDrupalPreviewContentFailure,
};
